import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import TaskDetailCore from './TaskDetailCore';
import TaskDetailModal from './TaskDetailModal';
import TaskDetailSidePanel from './TaskDetailSidePanel';

const TaskDetail = () => {
  const { taskId, ticketKey, taskKey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Support both old (taskId) and new (ticketKey) routing formats
  const identifier = taskKey || ticketKey || taskId;
  // Auto-detect: if it contains a dash (e.g., "TP1-15"), it's a key; otherwise numeric ID
  const identifierType = ticketKey || (identifier && isNaN(identifier)) ? 'key' : 'id';

  // Detect render mode from location state
  const viewMode = location.state?.viewMode || 'fullpage';
  const returnTo = location.state?.returnTo;
  const returnState = location.state?.returnState;

  const handleClose = () => {
    if (returnTo) {
      navigate(returnTo, { state: returnState });
    } else {
      navigate(-1);
    }
  };

  const handleDeleted = () => {
    // Task was deleted, navigate away
    handleClose();
  };

  // Render appropriate wrapper based on viewMode
  if (viewMode === 'modal') {
    return (
      <TaskDetailModal
        identifier={identifier}
        identifierType={identifierType}
        onClose={handleClose}
        onDeleted={handleDeleted}
      />
    );
  }

  if (viewMode === 'sidepanel') {
    return (
      <TaskDetailSidePanel
        identifier={identifier}
        identifierType={identifierType}
        onClose={handleClose}
        onDeleted={handleDeleted}
      />
    );
  }

  // Default: full page mode
  return (
    <TaskDetailCore
      identifier={identifier}
      identifierType={identifierType}
      renderMode="fullpage"
      onClose={handleClose}
      onDeleted={handleDeleted}
    />
  );
};

export default TaskDetail;
